import React, { Component } from "react";
import { Layout, ContactForm, GoogleMapComponent } from "../../components";
import locales from "../../constants";
import $ from "jquery";

class Kontakt extends Component {
  componentDidMount() {
    $(".contact_section_2 ul li").click(function () {
      var liID = $(this).attr("data-id");
      $(".contact_section_2 ul li").removeClass("current");
      $(this).addClass("current");

      $(".contact_section_2 .wrapper").each(function () {
        var wrapperID = $(this).attr("data-id");
        if (liID === wrapperID) {
          $(this).show();
        } else {
          $(this).hide();
        }
      });
    });
  }
  render() {
    const { slug } = this.props.pageContext;
    const lang = "en";

    return (
      <Layout
        seo={{
          title: "Contact",
          href: slug,
          lang: "en",
        }}
        langSwitch={{
          langKey: "pl",
          langSlug: "/kontakt/",
        }}
      >
        {/* eslint-disable jsx-a11y/label-has-associated-control */}
        <section className="container-fluid contact_section_1">
          <div className="text-center">
            <h1>Contact</h1>
          </div>
          <div className="row">
            <div className="col-md-5 col_1">
              <p>Contact:</p>
              <a href="tel:+48123078880" className="link">
                12 307 88 80
              </a>
              <br />
              <a href="mailto:biuro@adream.pl" className="link">
                biuro@adream.pl
              </a>
              <div className="divider" />
              <p>Headquarters:</p>
              <address>
                Adream sp. z o.o. <br />
                ul. Chopina 18/3a <br />
                30-047 Kraków <br />
                <br />
                KRS: 0000517132 <br />
                NIP: 6762477695 <br />
                REGON: 123163480
              </address>
              <div className="divider" />
              <p>Back account:</p>
              <address>mBank 84 1140 2004 0000 3602 7529 1638</address>
            </div>
            <div className="col-md-7">
              <ContactForm locales={locales[lang]} lang="en" />
            </div>
          </div>
        </section>

        <section className="contact_section_2">
          <ul>
            <li data-id="map" className="current">
              <label>Map</label>
              <svg width="21px" height="29px">
                <g>
                  <g id="Shape-16" transform="matrix(1,0,0,1,-52.9999,-1566)">
                    <path d="M63.5,1595C63.286,1595 63.082,1594.91 62.939,1594.75C62.533,1594.3 53,1583.66 53,1576.44C53,1570.68 57.71,1566 63.5,1566C69.29,1566 74,1570.68 74,1576.44C74,1583.65 64.467,1594.3 64.061,1594.75C63.918,1594.91 63.714,1595 63.5,1595L63.5,1595ZM63.5,1567.5C58.542,1567.5 54.508,1571.51 54.508,1576.44C54.508,1582.05 61.267,1590.47 63.339,1592.91L63.5,1593.11L63.661,1592.91C65.733,1590.47 72.492,1582.04 72.492,1576.44C72.492,1571.51 68.458,1567.5 63.5,1567.5ZM63.5,1581.6C60.645,1581.6 58.322,1579.29 58.322,1576.44C58.322,1573.61 60.645,1571.29 63.5,1571.29C66.355,1571.29 68.678,1573.61 68.678,1576.44C68.678,1579.29 66.355,1581.6 63.5,1581.6ZM63.5,1572.79C61.476,1572.79 59.829,1574.43 59.829,1576.44C59.829,1578.46 61.476,1580.1 63.5,1580.1C65.524,1580.1 67.171,1578.46 67.171,1576.44C67.171,1574.43 65.524,1572.79 63.5,1572.79Z" />
                  </g>
                </g>
              </svg>
            </li>
            <li data-id="office">
              <label>The interior of office</label>
              <svg
                width="32px"
                height="29px"
                viewBox="0 0 134 121"
                version="1.1"
              >
                <g transform="matrix(4.16667,0,0,4.16667,0,0)">
                  <g id="Shape-16-copy" transform="matrix(1,0,0,1,-101,-1566)">
                    <path d="M117.126,1595L117.122,1595C116.779,1595 116.499,1594.73 116.497,1594.39C116.495,1594.05 116.774,1593.77 117.119,1593.77L117.156,1593.77C117.501,1593.77 117.781,1594.05 117.781,1594.38C117.781,1594.73 117.501,1595 117.156,1595L117.126,1595ZM132.145,1582.91C132.491,1582.92 132.77,1583.19 132.77,1583.53C132.77,1583.86 132.502,1584.13 132.167,1584.14C132.72,1584.99 133,1585.88 133,1586.8C133,1588.83 131.591,1590.76 129.033,1592.24C126.621,1593.64 123.299,1594.58 119.679,1594.89C119.661,1594.89 119.643,1594.89 119.625,1594.89C119.304,1594.89 119.031,1594.65 119.003,1594.33C118.973,1593.99 119.228,1593.69 119.572,1593.66C126.514,1593.07 131.75,1590.12 131.75,1586.8C131.75,1586.26 131.612,1585.72 131.339,1585.19C131.225,1585.31 131.064,1585.38 130.886,1585.38C130.541,1585.38 130.261,1585.11 130.261,1584.77L130.261,1583.53C130.261,1583.19 130.541,1582.92 130.886,1582.91L132.145,1582.91ZM114.425,1593.66C107.484,1593.07 102.25,1590.12 102.25,1586.8C102.25,1586.02 102.533,1585.25 103.09,1584.52C103.296,1584.24 103.238,1583.86 102.961,1583.66C102.684,1583.45 102.293,1583.51 102.087,1583.78C101.366,1584.74 101,1585.75 101,1586.8C101,1588.82 102.408,1590.76 104.966,1592.24C107.377,1593.64 110.698,1594.58 114.318,1594.89C114.336,1594.89 114.354,1594.89 114.372,1594.89C114.693,1594.89 114.966,1594.65 114.994,1594.33C115.024,1593.99 114.769,1593.69 114.425,1593.66ZM106.244,1584.93L116.687,1590.86C116.784,1590.91 116.892,1590.94 117,1590.94C117.108,1590.94 117.216,1590.91 117.312,1590.86L127.755,1584.93C127.949,1584.82 128.068,1584.62 128.068,1584.4L128.068,1572.54C128.068,1572.32 127.949,1572.12 127.755,1572.01L117.312,1566.08C117.119,1565.97 116.881,1565.97 116.687,1566.08L106.244,1572.01C106.051,1572.12 105.932,1572.32 105.932,1572.54L105.932,1584.4C105.932,1584.62 106.051,1584.82 106.244,1584.93ZM126.818,1583.33L126.227,1583C125.928,1582.83 125.546,1582.93 125.373,1583.22C125.2,1583.52 125.303,1583.89 125.602,1584.06L126.193,1584.4L117.625,1589.26L117.625,1579.53L118.703,1580.15C118.802,1580.2 118.909,1580.23 119.015,1580.23C119.231,1580.23 119.441,1580.12 119.557,1579.92C119.73,1579.63 119.627,1579.25 119.328,1579.08L118.255,1578.47L126.818,1573.61L126.818,1583.33ZM115.745,1578.47L114.672,1579.08C114.373,1579.25 114.27,1579.63 114.443,1579.92C114.559,1580.12 114.769,1580.23 114.985,1580.23C115.091,1580.23 115.198,1580.2 115.297,1580.15L116.375,1579.53L116.375,1589.26L107.807,1584.4L108.398,1584.06C108.697,1583.89 108.799,1583.52 108.627,1583.22C108.454,1582.93 108.072,1582.83 107.773,1583L107.182,1583.33L107.182,1573.61L115.745,1578.47ZM121.562,1581.77L122.743,1582.44C122.842,1582.5 122.949,1582.52 123.055,1582.52C123.271,1582.52 123.481,1582.41 123.597,1582.21C123.77,1581.92 123.667,1581.55 123.368,1581.38L122.187,1580.7C121.888,1580.54 121.506,1580.63 121.333,1580.93C121.16,1581.22 121.263,1581.6 121.562,1581.77ZM110.945,1582.52C111.051,1582.52 111.158,1582.5 111.257,1582.44L112.438,1581.77C112.737,1581.6 112.839,1581.22 112.667,1580.93C112.494,1580.63 112.112,1580.54 111.813,1580.7L110.632,1581.38C110.333,1581.55 110.23,1581.92 110.403,1582.21C110.519,1582.41 110.729,1582.52 110.945,1582.52ZM117,1568.99C117.345,1568.99 117.625,1568.72 117.625,1568.38L117.625,1567.68L126.193,1572.54L117.625,1577.41L117.625,1576.21C117.625,1575.87 117.345,1575.59 117,1575.59C116.655,1575.59 116.375,1575.87 116.375,1576.21L116.375,1577.41L107.807,1572.54L116.375,1567.68L116.375,1568.38C116.375,1568.72 116.655,1568.99 117,1568.99ZM116.375,1572.96C116.375,1573.3 116.655,1573.58 117,1573.58C117.345,1573.58 117.625,1573.3 117.625,1572.96L117.625,1571.62C117.625,1571.28 117.345,1571.01 117,1571.01C116.655,1571.01 116.375,1571.28 116.375,1571.62L116.375,1572.96Z" />
                  </g>
                </g>
              </svg>
            </li>
          </ul>
          <div className="wrapper map" data-id="map">
            <div className="acf-map">
              <GoogleMapComponent
                googleMapURL="https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=AIzaSyDNFJB1acI3G5H1JBkWHjDYJgLkRAzA4Vg"
                loadingElement={<div style={{ height: `100%` }} />}
                containerElement={<div style={{ height: `100%` }} />}
                mapElement={<div style={{ height: `100%` }} />}
                isInfoboxVisible={false} // Show/hide info window
                infoboxMessage={""} // Message shown in info window
              />
            </div>
          </div>
          <div
            className="wrapper office"
            data-id="office"
            style={{ display: "none" }}
          >
            <iframe
              src="https://www.google.com/maps/embed?pb=!4v1519114268969!6m8!1m7!1sCAoSLEFGMVFpcFBIMHIxUWF0NkI2b3Q5UHVOOUJfX2JOVXZnczZmeVJFeHNhUEJu!2m2!1d50.06838862566719!2d19.92131017148495!3f115.87138782901212!4f-7.108826956587592!5f0.7820865974627469"
              width="100%"
              title="google"
              height="400"
              frameBorder="0"
              style={{ border: 0 }}
              allowFullScreen=""
            />
          </div>
        </section>
      </Layout>
    );
  }
}

export default Kontakt;
